// 2024 (SRD 5.2) weapon property text shown in attack tooltips.
const weaponProperties = {
  Ammunition:
    "You can make a ranged attack with this weapon only if you have the right ammunition. Each attack expends one piece, and drawing it is part of the attack (loading a one-handed weapon needs a free hand). After a fight, you can spend 1 minute to recover half the ammunition you used.",
  Finesse:
    "When making an attack with a Finesse weapon, use your choice of your Strength or Dexterity modifier for the attack and damage rolls. You must use the same modifier for both rolls.",
  Heavy:
    "You have Disadvantage on attack rolls with a Heavy weapon if it's a Melee weapon and your Strength score is below 13, or if it's a Ranged weapon and your Dexterity score is below 13.",
  Light:
    "After you attack with this weapon as part of the Attack action, you can make one extra attack later that turn with a different Light weapon, normally as a Bonus Action. Don't add your ability modifier to that extra attack's damage unless it is negative.",
  Loading:
    "You can fire only one piece of ammunition from a Loading weapon when you use an action, a Bonus Action or a Reaction to fire it, regardless of the number of attacks you can normally make.",
  Range:
    "A weapon with a range lists two numbers after its Ammunition or Thrown property: its normal range and its long range, in feet. Attacks beyond normal range have Disadvantage, and you can't attack beyond long range.",
  Reach:
    "This weapon adds 5 feet to your reach when you attack with it, as well as when determining your reach for Opportunity Attacks with it.",
  Thrown:
    "You can throw this weapon to make a ranged attack, and you can draw it as part of the attack. If it's a Melee weapon, use the same ability modifier for the attack and damage rolls that you use for a melee attack with it.",
  "Two-Handed":
    "This weapon requires two hands when you attack with it.",
  Versatile:
    "This weapon can be used with one or two hands. The damage in parentheses applies when you use it with two hands to make a melee attack.",
};

export default weaponProperties;
